import styled from "styled-components";

export const NavegacaoDrawer = styled.div`
    width: 100%;
    height: 30px;
    background-color: #fff;
`